export function getV1ErrorMessage(error: unknown, fallback: string): string {
    const message = (error as { data?: { message?: unknown } })?.data?.message;
    if (typeof message !== 'string' || message === '') {
        return fallback;
    }
    return getValidationErrorsText(message) ?? message;
}

function getValidationErrorsText(message: string): string | null {
    let parsed: unknown;
    try {
        parsed = JSON.parse(message);
    } catch {
        return null;
    }
    if (parsed == null || typeof parsed !== 'object' || Array.isArray(parsed)) {
        return null;
    }
    const errors = Object.values(parsed).flat().filter((value) => typeof value === 'string');
    return errors.length > 0 ? errors.join(' ') : null;
}
